import React, { useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, arrayUnion, addDoc } from "firebase/firestore";

export default function AddSpecialOffer({ uploadedBy }) {
    const [offerName, setOfferName] = useState("");
    const [offerDescription, setOfferDescription] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    // Convert local date input to CST start of day / end of day
    const toCSTDate = (dateStr, isEnd) => {
        if (!dateStr) return null;
        const d = new Date(dateStr);
        // Create new Date in CST (UTC-6) manually
        const offset = 6 * 60; // CST = UTC-6 hours
        if (isEnd) {
            d.setHours(23, 59, 59, 999);
        } else {
            d.setHours(0, 0, 0, 0);
        }
        // convert to UTC equivalent time
        return new Date(d.getTime() + offset * 60000);
    };

    const handleSave = async () => {
  if (!offerName.trim()) {
    setMessage("❌ Offer name is required");
    return;
  }
  if (!startDate || !endDate) {
    setMessage("❌ Please select both start and end dates");
    return;
  }

  try {
    setSaving(true);
    setMessage("");

    // 1️⃣ Fetch existing docs in special_offer
    const snap = await getDocs(collection(db, "special_offer"));
    let existingDocRef = null;

    // 2️⃣ Find the first doc that has an offers array (even empty)
    snap.forEach((docSnap) => {
      const data = docSnap.data();
      if (Array.isArray(data.offers)) {
        existingDocRef = docSnap.ref;
      }
    });

    const newOffer = {
      offerName: offerName.trim(),
      offerDescription: offerDescription.trim(),
      startDttm: toCSTDate(startDate, false),
      endDttm: toCSTDate(endDate, true),
      uploadedBy: uploadedBy || "admin",
      uploadedDttm: new Date(),
    };

    if (existingDocRef) {
      // ✅ Append to the existing offers array in that document
      await updateDoc(existingDocRef, {
        offers: arrayUnion(newOffer),
      });
    } else {
      // 🆕 No existing doc found — create one
      await addDoc(collection(db, "special_offer"), { offers: [newOffer] });
    }

    setMessage("✅ Special offer added successfully!");
    setOfferName("");
    setOfferDescription("");
    setStartDate("");
    setEndDate("");
  } catch (err) {
    console.error("Error adding special offer:", err);
    setMessage("❌ Failed to add special offer.");
  } finally {
    setSaving(false);
  }
};

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-semibold mb-4 text-center">
                🎁 Add Special Offer
            </h2>

            <div className="flex flex-col gap-4">
                <label className="flex flex-col">
                    Offer Name:
                    <input
                        type="text"
                        value={offerName}
                        onChange={(e) => setOfferName(e.target.value)}
                        className="border rounded p-2 mt-1"
                    />
                </label>

                <label className="flex flex-col">
                    Description:
                    <textarea
                        rows="3"
                        value={offerDescription}
                        onChange={(e) => setOfferDescription(e.target.value)}
                        className="border rounded p-2 mt-1"
                    />
                </label>

                <div className="grid grid-cols-2 gap-4">
                    <label className="flex flex-col">
                        Start Date:
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="border rounded p-2 mt-1"
                        />
                    </label>

                    <label className="flex flex-col">
                        End Date:
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="border rounded p-2 mt-1"
                        />
                    </label>
                </div>

                <button
                    onClick={handleSave}
                    disabled={saving}
                    className="bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 disabled:opacity-50 transition"
                >
                    {saving ? "Saving..." : "Save Offer"}
                </button>

                {message && (
                    <p className="mt-2 text-center text-sm text-red-600 whitespace-pre-line">
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
}
